// extracted by mini-css-extract-plugin
export default {"button":"build-a-box-cart-button__button___QmTSz"};